import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalControlService {
  #onOpenModal = new EventEmitter();
  #showModal = false;
  
  get showModal() {
    return this.#showModal;
  }
  get onOpenModal(): EventEmitter<any> {
    return this.#onOpenModal;
  }
  
  openModal() {
    this.#showModal = true;
    this.#onOpenModal.emit();
  }

  closeModal() {
    this.#showModal = false;
    this.#onOpenModal.emit();
  }
}